import { __assign, __extends } from "tslib";
import React from 'react';
import { compareArrayValues, compareDataFrameStructures } from '@grafana/data';
import { VizLayout } from '../VizLayout/VizLayout';
import { UPlotChart } from '../uPlot/Plot';
import { withTheme } from '../../themes';
import { preparePlotConfigBuilder, preparePlotFrame } from './utils';
import { preparePlotData } from '../uPlot/utils';
import { LegendDisplayMode } from '../VizLegend/types';
import { PlotLegend } from '../uPlot/PlotLegend';
var UnthemedBarChart = /** @class */ (function (_super) {
    __extends(UnthemedBarChart, _super);
    function UnthemedBarChart(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    UnthemedBarChart.getDerivedStateFromProps = function (props, state) {
        var frame = preparePlotFrame(props.data);
        if (!frame) {
            return __assign({}, state);
        }
        return __assign(__assign({}, state), { data: preparePlotData(frame), alignedDataFrame: frame });
    };
    UnthemedBarChart.prototype.componentDidMount = function () {
        var alignedDataFrame = this.state.alignedDataFrame;
        if (!alignedDataFrame) {
            return;
        }
        this.setState({
            config: preparePlotConfigBuilder(alignedDataFrame, this.props.theme, this.props),
        });
    };
    UnthemedBarChart.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, data = _a.data, orientation = _a.orientation, groupWidth = _a.groupWidth, barWidth = _a.barWidth, showValue = _a.showValue;
        var alignedDataFrame = this.state.alignedDataFrame;
        var shouldConfigUpdate = false;
        var hasStructureChanged = false;
        if (this.state.config === undefined ||
            orientation !== prevProps.orientation ||
            groupWidth !== prevProps.groupWidth ||
            barWidth !== prevProps.barWidth ||
            showValue !== prevProps.showValue) {
            shouldConfigUpdate = true;
        }
        if (data !== prevProps.data) {
            if (!alignedDataFrame) {
                return;
            }
            hasStructureChanged = !compareArrayValues(data, prevProps.data, compareDataFrameStructures);
        }
        if (shouldConfigUpdate || hasStructureChanged) {
            this.setState({
                config: preparePlotConfigBuilder(alignedDataFrame, this.props.theme, this.props),
            });
        }
    };
    UnthemedBarChart.prototype.renderLegend = function () {
        var _a = this.props, legend = _a.legend, onSeriesColorChange = _a.onSeriesColorChange, onLegendClick = _a.onLegendClick, data = _a.data;
        var config = this.state.config;
        if (!config || legend.displayMode === LegendDisplayMode.Hidden) {
            return;
        }
        return (React.createElement(PlotLegend, __assign({ data: data, config: config, onSeriesColorChange: onSeriesColorChange, onLegendClick: onLegendClick, maxHeight: "35%", maxWidth: "60%" }, legend)));
    };
    UnthemedBarChart.prototype.render = function () {
        var _a = this.props, width = _a.width, height = _a.height;
        var _b = this.state, config = _b.config, data = _b.data;
        if (!config) {
            return null;
        }
        return (React.createElement(VizLayout, { width: width, height: height, legend: this.renderLegend() }, function (vizWidth, vizHeight) { return (React.createElement(UPlotChart, { data: data, config: config, width: vizWidth, height: vizHeight, timeRange: { from: 1, to: 1 } })); }));
    };
    return UnthemedBarChart;
}(React.Component));
export var BarChart = withTheme(UnthemedBarChart);
BarChart.displayName = 'GraphNG';
//# sourceMappingURL=BarChart.js.map